var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9493 12.1737C18.2465 12.1737 17.9021 12.4083 17.9021 12.6979V16.3524C17.9011 17.2204 17.1977 17.924 16.3295 17.925H3.621C2.75279 17.924 2.04942 17.2204 2.0484 16.3524V4.69229C2.04942 3.82408 2.75279 3.12071 3.621 3.11969H7.27532C7.56485 3.11969 7.79952 2.5 7.79952 2C7.79952 1.5 7.56485 1.07129 7.27532 1.07129H2.621C1.17412 1.07293 0.00163812 2.24541 0 3.69229V17.3524C0.00163812 18.7993 1.17412 19.9718 2.621 19.9734H17.3295C18.7764 19.9718 19.9489 18.7993 19.9505 17.3524V12.6981C19.9505 12.4085 19.6521 12.1737 18.9493 12.1737Z",
    fill: "#18A0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33984 11.013L14.5499 2.80273L17.1977 5.45054L8.98765 13.6608L6.33984 11.013Z",
    fill: "#18A0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15.0003L7.9261 14.1898L5.81049 12.0742L5 15.0003Z",
    fill: "#18A0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9281 1.41101C17.3788 0.862997 16.4894 0.862997 15.9401 1.41101L15.3438 2.00734L17.9916 4.65515L18.5879 4.05882C19.1361 3.50949 19.1361 2.62015 18.5879 2.07082L17.9281 1.41101Z",
    fill: "#18A0FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.581fd4b511d2441bc0549ac057624c31.svg";
export { ForwardRef as ReactComponent };